<template>
  <v-app
    id="app-portal"
    class="app"
  >
    <v-theme-provider
      class="theme-provider"
      :[theme]="true"
    >
      <router-view />
    </v-theme-provider>
    <!--<portal-target
      class="portal-target"
      name="dnd-ghost"
    />
    <!~~ render floating-ui elements ~~>
    <portal-target
      multiple
      class="portal-target"
      name="floating-ui"
    />-->
    <div id="floating-ui" />
  </v-app>
</template>

<script lang="ts" setup>
import { useTheme } from './composables/theme'

// console.log('dev', !import.meta.env.PROD)

const { theme } = useTheme()
</script>

<style>
/* custom scrollbar */
::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  background-color: #fcfcfc;
}

::-webkit-scrollbar-thumb {
  background-color: rgb(221 221 221 / 0.75);
  border-radius: 20px;
  border: 2px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}
</style>
